import getEmployeeStateTransitionPresets from "./getEmployeeStateTransitionPresets";

export default {
  EMPLOYEE_STATE_TRANSITION_PRESETS: getEmployeeStateTransitionPresets,
}
